import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card"
}
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "fw-bold fs-4 text-danger text-center" }
const _hoisted_6 = { class: "text-center my-4 border-top-2" }
const _hoisted_7 = { class: "bg-primary p-3 text-white fw-bold" }
const _hoisted_8 = {
  key: 0,
  class: "col-6"
}
const _hoisted_9 = { class: "d-flex align-center" }
const _hoisted_10 = { class: "col-6" }
const _hoisted_11 = { class: "d-flex align-center" }
const _hoisted_12 = {
  key: 1,
  class: "text-center py-5"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h1", null, "No lessons are scheduled for this date.", -1)
const _hoisted_14 = [
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WeeklyFilter = _resolveComponent("WeeklyFilter")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_ctx.can('read', 'settings'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_WeeklyFilter, {
              "disabled-range": _ctx.disabledRangeDate,
              onDateRangeChanged: _ctx.getLessonsGroupByDate
            }, null, 8, ["disabled-range", "onDateRangeChanged"])
          ])
        ]),
        (_ctx.studentsCount > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.studentsCount) + " Students in this week ", 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (data) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "card-body pt-0 border-3",
                  key: data.id
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("h1", _hoisted_7, _toDisplayString(data[0].date), 1)
                  ]),
                  _createVNode(_component_Datatable, {
                    class: "table-striped",
                    "table-data": _ctx.groupedByWeekList,
                    "table-header": _ctx.tableHeader,
                    "total-items": 10,
                    "rows-per-page": 100,
                    loading: _ctx.loading,
                    "enable-items-per-page-dropdown": false,
                    "enable-accordion": true
                  }, {
                    "cell-classType": _withCtx(({ row: lesson }) => [
                      _createTextVNode(_toDisplayString(lesson[0].classType), 1)
                    ]),
                    "cell-time": _withCtx(({ row: lesson }) => [
                      _createTextVNode(_toDisplayString(lesson[0].time), 1)
                    ]),
                    "cell-arenaName": _withCtx(({ row: lesson }) => [
                      _createTextVNode(_toDisplayString(lesson[0].arenaName), 1)
                    ]),
                    accordion: _withCtx(({ row: lessons }) => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data, (lesson) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "row",
                          key: lesson.id
                        }, [
                          lessons
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _createElementVNode("span", _hoisted_9, _toDisplayString(lesson.customerName), 1)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("span", _hoisted_11, _toDisplayString(lesson.horseName), 1)
                          ])
                        ]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1032, ["table-data", "table-header", "loading"])
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
      ]))
    : _createCommentVNode("", true)
}